import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "config/store";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { IEdoQuestion } from "shared/model/edo-question.model";
import { deleteEntity } from "shared/reducers/entities/edo-question.reducer";
import { EntityState } from "shared/reducers/reducer.utils";

interface IDeleteQuestionProps {
    question: IEdoQuestion;
    open: boolean;
    onClose: () => void;
}

const DeleteQuestion = (props: IDeleteQuestionProps) => {
    const dispatch = useAppDispatch();
    const { updateSuccess } = useAppSelector<EntityState<IEdoQuestion>>(
        (state) => state.edoQuestion
    );

    const { question, open, onClose: handleClose } = props;

    const confirmDelete = () => {
        dispatch(deleteEntity(question.id));
    };

    useEffect(() => {
        if (open && updateSuccess) {
            handleClose();
        }
    }, [updateSuccess]);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                <Translate contentKey="entity.delete.title">
                    Confirm delete operation
                </Translate>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Translate
                        contentKey="edocendoApp.edoQuestion.delete.question"
                    >
                        Are you sure you want to delete this EdoQuestion?
                    </Translate>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    <Translate contentKey="entity.action.cancel">Cancel</Translate>
                </Button>
                <Button onClick={confirmDelete} color="primary">
                    <Translate contentKey="entity.action.delete">Delete</Translate>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteQuestion;